enum DocumentVersionAttachmentType {
    File = 0,
    Link = 1
}

export default DocumentVersionAttachmentType;